"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorSigner = void 0;
const errors_1 = require("../errors");
const validatorKeys_1 = require("./validatorKeys");
/**
 * Validator signer (BLS signer)
 */
class ValidatorSigner {
    /**
     * Signs a message.
     */
    async signUsingPem(pemText, pemIndex = 0, signable) {
        await validatorKeys_1.BLS.initIfNecessary();
        try {
            let secretKey = validatorKeys_1.ValidatorSecretKey.fromPem(pemText, pemIndex);
            secretKey.sign(signable);
        }
        catch (err) {
            throw new errors_1.ErrSignerCannotSign(err);
        }
    }
}
exports.ValidatorSigner = ValidatorSigner;
//# sourceMappingURL=validatorSigner.js.map